import React from 'react';
import PropTypes from 'prop-types';
import { NkButton } from '@nordkap/nordkap-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus as Add,
  faTrash as Delete,
} from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { TemplateContainer } from './utils';
import { combineClasses } from '../../utils/styling';
import { useStyles } from './styles';

const RuleRowHeader = ({
  index,
  eventType,
  headerText,
  showAddButton = true,
  showDeleteButton = true,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const templateContainer = TemplateContainer.useContainer();

  const MemoizedFontAwesomeAddIcon = React.useCallback(
    () => <FontAwesomeIcon icon={Add} />,
    []
  );
  const MemoizedFontAwesomeDeleteIcon = React.useCallback(
    () => <FontAwesomeIcon icon={Delete} />,
    []
  );
  return (
    <>
      <p
        className={combineClasses([
          classes.Bold,
          classes.UpperCase,
          classes.EventTypeName,
        ])}
      >
        {headerText}
      </p>
      <div className={classes.RuleButtons}>
        {showAddButton && (
          <NkButton
            name={t('positionPage.addRule')}
            icon={() => MemoizedFontAwesomeAddIcon()}
            onClick={() => templateContainer.addRule(eventType, index + 1)}
            size="small"
            color="primary"
          />
        )}

        {showDeleteButton && (
          <NkButton
            name={t('positionPage.deleteRule')}
            icon={() => MemoizedFontAwesomeDeleteIcon()}
            onClick={() => templateContainer.deleteRule(eventType, index)}
            size="small"
            color="primary"
          />
        )}
      </div>
    </>
  );
};

RuleRowHeader.propTypes = {
  headerText: PropTypes.string,
  eventType: PropTypes.string,
  index: PropTypes.number,
  showAddButton: PropTypes.bool,
  showDeleteButton: PropTypes.bool,
};

export default React.memo(RuleRowHeader);
